import * as notificationsActions from "../actions/notifications.actions";

import { Notification } from "cli-types";

// creating an interface to say what type the initialState will be
// using entities (data objects) instead of arrays is better for perforance
export interface NotificationsListState {
    entities: Map<number, Notification>;
    loaded: boolean;
    loading: boolean;
    announcements: Notification[];
    privateMessages: Notification[];
    messagesTab: number | null;
    messagesPanel: boolean;
}

// set initial state as type NotificationsListState
export const initialState: NotificationsListState = {
    entities: new Map<number, Notification>(),
    loaded: false,
    loading: false,
    announcements: [],
    privateMessages: [],
    messagesTab: null,
    messagesPanel: false,
};

export function reducer(
    state = initialState,
    action: notificationsActions.NotificationsAction
): NotificationsListState {
    switch (action.type) {
        case notificationsActions.LOAD_NOTIFICATIONS: {
            return {
                ...state,
                loading: true,
            };
        }

        case notificationsActions.LOAD_NOTIFICATIONS_SUCCESS: {
            const notifications = action.payload.data;

            const entities = new Map<number, Notification>();
            notifications.forEach((notification) => {
                entities.set(notification.noticeID, notification);
            });

            return {
                ...state,
                entities: entities,
                loading: false,
                loaded: true,
                announcements: action.payload.data.filter(
                    (n) => n.type === "announcement"
                ),
                privateMessages: action.payload.data.filter(
                    (n) => n.type === "pm"
                ),
            };
        }

        case notificationsActions.LOAD_NOTIFICATIONS_FAIL:
        case notificationsActions.MARK_AS_READ_FAIL: {
            return {
                ...state,
                loading: false,
                loaded: false,
            };
        }

        case notificationsActions.MARK_AS_READ_SUCCESS: {
            const notification = action.payload;
            const updatedNotification = new Map<number, Notification>(
                state.entities.entries()
            );
            updatedNotification.set(notification.noticeID, notification);

            return {
                ...state,
                entities: updatedNotification,
            };
        }

        case notificationsActions.SET_MESSAGES_TAB: {
            return {
                ...state,
                messagesTab: action.payload,
            };
        }

        case notificationsActions.OPEN_MESSAGES_PANEL: {
            return {
                ...state,
                messagesPanel: action.payload,
            };
        }
    }
    return state;
}

export const getNotificationsEntities = (state: NotificationsListState) =>
    state.entities;
export const getNotificationsLoading = (state: NotificationsListState) =>
    state.loading;
export const getNotificationsLoaded = (state: NotificationsListState) =>
    state.loaded;
export const getAnnouncements = (state: NotificationsListState) =>
    state.announcements;
export const getPrivateMessages = (state: NotificationsListState) =>
    state.privateMessages;
export const getMessagesTab = (state: NotificationsListState) =>
    state.messagesTab;
export const openMessagesPanel = (state: NotificationsListState) =>
    state.messagesPanel;
